import { RequestInit } from 'next/dist/server/web/spec-extension/request';

export function fetcher<TData, TVariables>(
	query: string,
	variables?: TVariables,
	fetchVariables?: RequestInit['headers']
) {
	return async (): Promise<TData> => {
		const res = await fetch(process.env.NEXT_PUBLIC_SANITY_API_URL, {
			method: 'POST',
			...{
				headers: {
					Authorization: `Bearer ${process.env.NEXT_PUBLIC_SANITY_ACCESS_TOKEN}`,
					'Content-Type': 'application/json',
				},
			},
			body: JSON.stringify({ query, variables }),
			...fetchVariables,
		});

		const json = await res.json();

		if (json.errors) {
			const { message } = json.errors[0];

			throw new Error(message);
		}

		return json.data;
	};
}
